<template>
    <Map class="animated fadeIn" />
</template>

<script>
import Map from '@/components/Map';

export default {
    components: {
        Map
    }
};
</script>
